export enum UnhealthyServiceEvents {
    EngagementsAccountsFetchHasErrors = "Engagements_AccountsFetchHasErrors",
    EngagementsAccountsFetchFailed = "Engagements_AccountsFetchFailed",
    EngagementsCustomerFetchFailed = "Engagements_CustomerFetchFailed",
    IdmAuthTokenFetchFailed = "IDM_AuthTokenFetchFailed",
    MoneyTransferTransferFailed = "MoneyTransfer_TransferFailed"
}